import type { RaffleCompletion } from "./types";

type Volumes = Pick<
  RaffleCompletion,
  "volume_done_usdt" | "volume_required_usdt"
>;

// Считаем сами из объёмов: 150 / 250 → 60%. Без требования по объёму — 100%.
export const getCompletionPercent = ({
  volume_done_usdt,
  volume_required_usdt,
}: Volumes): number => {
  const required = Number(volume_required_usdt);
  if (!(required > 0)) return 100;
  const percent = (Number(volume_done_usdt) / required) * 100;
  return Math.min(100, Math.max(0, Math.floor(percent)));
};
